import importService from "../../services/ClassenService/modules/exportService";

const state = {};

const mutations = {};

const getters = {};

const actions = {
  uploadExcel: ({commit}, uploadData) => new Promise((resolve, reject) => {
    importService.uploadExcel(uploadData)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => reject(error));
  })
};

export default {
  state, mutations, getters, actions,
};
